export const sliderItems = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/Banner_Clothing.jpg",
    title: "SUMMER SALE",
    desc: "DON'T COMPOMISE OM STYLE1 GET FLAT SALE OF 30% FOR NEW ARRIVALS",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/Banner_Clothing.jpg",
    title: "WINNER SALE",
    desc: "DON'T COMPOMISE OM STYLE1 GET FLAT SALE OF 30% FOR NEW ARRIVALS",
    bg: "fcfled",
  },
  {
    id: 3,
    img: "https://ananas.vn/wp-content/uploads/Banner_Clothing.jpg",
    title: "POPULAR SALE",
    desc: "DON'T COMPOMISE OM STYLE1 GET FLAT SALE OF 30% FOR NEW ARRIVALS",
    bg: "fbf0f4",
  },
];
export const categories = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/banner-phu%CC%A3_2m-600x320.jpg",
    title: "SHIRT STYLE",
    cat: "women",
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/banner-phu%CC%A3_2m-600x320.jpg",
    title: "YOUNGER OUTFIT",
    cat: "coat",
  },
  {
    id: 3,
    img: "https://ananas.vn/wp-content/uploads/banner-phu%CC%A3_2m-600x320.jpg",
    title: "JEAN SHOT",
    cat: "jeans",
  },
];
export const popularProducts = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_1.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61043_5.jpg",
    ],
    color: "Black",
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
    title: "URBAS UNSETTLING - LOW TOP - STARLIGHT/LAVENDER",
    code: "A61043",
    desc: 'Sở hữu công thức pha màu "khó chịu". Urbas Unsettling tạo nên điểm nhấn mạnh mẽ, gây kích thích thị giác thông qua sự đối lập trong từng gam màu. Điểm chốt hạ cho một outfit đặc biệt thú vị, tách biệt khỏi sự trùng lặp thông thường.',
    price: 390000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_5.jpg",
    ],
    color: "Black",
  },
  {
    id: 3,
    img: "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
    title: "VINTAS MISTER - LOW TOP - NARCISSUEDE",
    code: "A61039",
    desc: "Dáng Low Top truyền thống, kết hợp cùng phối màu gợi nét cổ điển, xưa cũ với chất liệu da Suede. Một sự lựa chọn của những ai muốn làm nổi bật lên sự chín chắn, tính điềm đạm cùng nét lịch thiệp cho bộ outfit của mình.",
    price: 580000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_5.jpg",
    ],
    color: "Black",
  },
  {
    id: 4,
    img: "https://ananas.vn/wp-content/uploads/Pro_AV00076_1.jpg",
    title: "BASAS MONO BLACK NE - HIGH TOP - ALL BLACK",
    code: "AV00076",
    desc: "Nâng cấp chất liệu vải mới bền màu ổn định, kết hợp cùng vẻ ngoài ton sur ton từ trên xuống dưới cùng sắc đen cá tính, giúp phiên bản Basas Mono Black NE trở nên quyến rũ và tiện dụng hơn bao giờ hết. Đây hứa hẹn sẽ là sản phẩm lọt vào danh sách cho những tín đồ thường coi màu đen là sự ưu tiên.",
    price: 580000,
    slider: [
      "https://ananas.vn/wp-content/uploads/Pro_AV00076_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61018_2.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61018_3.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61018_4.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61018_5.jpg",
    ],
    color: "White",
  },
  {
    id: 5,
    img: "https://ananas.vn/wp-content/uploads/pro_track6_A6T003_1-500x500.jpg",
    title: "TRACK 6 TRIPLE BLACK - LOW TOP - BLACK",
    code: "A6T003",
    desc: 'Với cảm hứng từ Retro Sneakers và âm nhạc giai đoạn 1970s, Ananas Track 6 ra đời với danh hiệu là mẫu giày Cold Cement đầu tiên của Ananas - một thương hiệu giày Vulcanized. Chất liệu Storm Leather đáng giá "càn quét" toàn bộ bề mặt upper cùng những chi tiết thiết kế đặc trưng và mang nhiều ý nghĩa. Chắc rắng, Track 6 sẽ đem đến cho bạn sự tự nhiên thú vị như chính thông điệp bài hát Let it be của huyền thoại The Beatles gửi gắm. Màu all black huyền bí luôn có mặt trong danh sách best seller.',
    price: 990000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T003_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T003_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T003_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T003_6.jpg",
      "	https://ananas.vn/wp-content/uploads/pro_track6_A6T003_11.jpg",
    ],
    color: "White",
  },
  {
    id: 6,
    img: "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_1-1.jpg",
    title: "URBAS LEGO - LOW TOP - DEEP MIMOSA",
    code: "A61053",
    desc: 'Lấy cảm hứng từ món đồ chơi xếp hình quen thuộc cùng phong cách thời trang Color Block cá tính, Urbas "Lego" với sự kết hợp của những mảng màu nổi bật sẽ tạo nên một bức tranh đa sắc màu ngay dưới chân bạn, cùng bạn thu hút mọi ánh nhìn trên đường phố.',
    price: 450000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_1-1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_2-1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_3-1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_4-1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_urbas_A61053_5-1.jpg",
    ],
    color: "White",
  },
  {
    id: 7,
    img: "https://ananas.vn/wp-content/uploads/pro_AV00009_1-500x500.jpg",
    title: "BASAS BUMPER GUM NE - MULE - BLACK/GUM",
    code: "AV00011",
    desc: 'Giữ nguyên nét cơ bản tiện dụng của thế hệ trước, phiên bản Basas Hook NLoop NE (New Episode) ra mắt với chất liệu vải mới nâng tầm trải nghiệm, cùng với một số "chăm chút khác" trong phần chi tiết khó nhận ra, giúp bạn dễ dàng lên chân bằng quai dán hiện đại. Đây chắc chắn là một lựa chọn xu hướng với nhịp sống hiện đại và thoải mái cho những ngày vô lo, vô nghĩ.',
    price: 520000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_AV00009_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_AV00009_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_AV00009_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_AV00009_5.jpg",
      "https://ananas.vn/wp-content/uploads/pro_AV00009_3.jpg",
    ],
    color: "Blue",
  },
  {
    id: 8,
    img: "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_1.jpg",
    title: "TRACK 6 TRIPLE WHITE - LOW TOP - WHITE",
    code: "A6T002",
    desc: 'Với cảm hứng từ Retro Sneakers và âm nhạc giai đoạn 1970s, Ananas Track 6 ra đời với danh hiệu là mẫu giày Cold Cement đầu tiên của Ananas - một thương hiệu giày Vulcanized. Chất liệu Storm Leather đáng giá "càn quét" toàn bộ bề mặt upper cùng những chi tiết thiết kế đặc trưng và mang nhiều ý nghĩa. Chắc rằng, Track 6 sẽ đem đến cho bạn sự tự nhiên thú vị như chính thông điệp bài hát Let it be của huyền thoại The Beatles gửi gắm. Màu all white chắc nhiều bạn sẽ thích.',
    price: 990000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_7.jpg",
      "https://ananas.vn/wp-content/uploads/pro_track6_A6T002_5.jpg",
    ],
    color: "Blue",
  },
  {
    id: 9,
    img: "https://ananas.vn/wp-content/uploads/pro_A6T009_1.jpg",
    title: "TRACK 6 CLASS E - LOW TOP - CRAFTSMAN BLUE",
    code: "A6T009",
    desc: "Track 6 Class E (Essential, Enthusiasm) là bộ sản phẩm mang trên mình những yếu tố cơ bản trong cuộc sống thường ngày. Được sử dụng những chất liệu thường có trên những đôi giày cao cấp với da Nappa nhẵn bóng, lưới mesh nhỏ mịn kết hợp Suede (da lộn) phủ màu tạo nên tổng thể vừa tinh tế, với màu sắc nhã nhặn. Điểm nhấn thú vị trên chi tiết màu “Craftsman Blue” thể hiện một phần yếu tố cần thiết, đại diện cho niềm đam mê chế tác của con người với những thú vui gắn cùng thiên nhiên. Track 6 Class E - Craftsman Blue xứng đáng là một must-have item đối với những ai yêu thích sáng tạo và mong muốn thể hiện cá tính độc lập.",
    price: 1190000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_A6T009_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A6T009_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A6T009_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A6T009_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A6T009_5.jpg",
    ],
    color: "Blue",
  },
  {
    id: 10,
    img: "https://ananas.vn/wp-content/uploads/pro_A61111_1-500x500.jpg",
    title: "VINTAS TEMPERATE - HIGH TOP - DUSTY OLIVE",
    code: "A61111",
    desc: "Má ngoài Suede (da lộn), má trong phủ vải canvas kèm theo các chi tiết phối trộn chất da Nappa nâu trầm điềm đạm là ý đồ sắp xếp làm nên Vintas Temperate Pack. Với tông màu cảm hứng từ cỏ cây cùng khí hậu dịu mát rõ nét của vùng Ôn Đới. Điểm chốt hạ thuyết phục cho những con người sâu sắc, mang tâm hồn yêu thiên nhiên vô bờ bến.",
    price: 770000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_A61111_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61111_2.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61111_3.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61111_4.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61111_5.jpg",
    ],
    color: "Blue",
  },
];
export const White = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/stu_basas_A61024_1-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 3,
    img: "https://ananas.vn/wp-content/uploads/pro_A6T009_1-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
];
export const Black = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/pro_AV00009_1-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/Pro_AV00098_1-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 3,
    img: "https://ananas.vn/wp-content/uploads/Pro_AV00099_2-500x500.jpg",
    title: "BASEBALL CAP - BE POSITIVE - PINK",
    categori: "",
    code: "ABC100",
    desc: "Dễ dàng mix & match với nhiều loại trang phục và phong cách thời trang khác nhau, mũ bóng chày có thiết kế cổ điển cùng hoạ tiết thêu đơn giản chính là món phụ kiện không thể thiếu trong tủ đồ nhà bạn.",
    price: 275000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
];
export const Blue = [
  {
    id: 1,
    img: "https://ananas.vn/wp-content/uploads/pro_A6T009_1-500x500.jpg",
    title: "VINTAS EARTH - HIGH TOP - GOAT",
    code: "A61042",
    desc: "Sử dụng đồng thời chất liệu da Nappa, da Suede và vải Canvas trên kiểu dáng High Top cổ điển, tông màu trầm mặc gợi nhắc đến cây rừng đất đá. Một sản phẩm dành cho những tâm hồn thích lang thang, yêu tự do và mê xê dịch.",
    price: 495000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 2,
    img: "https://ananas.vn/wp-content/uploads/pro_A6T010_2-500x500.jpg",
    title: "VINTAS EARTH - HIGH TOP - GOAT",
    code: "A61042",
    desc: "Sử dụng đồng thời chất liệu da Nappa, da Suede và vải Canvas trên kiểu dáng High Top cổ điển, tông màu trầm mặc gợi nhắc đến cây rừng đất đá. Một sản phẩm dành cho những tâm hồn thích lang thang, yêu tự do và mê xê dịch.",
    price: 495000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
  {
    id: 3,
    img: "https://assets.adidas.com/images/w_383,h_383,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/f02c5a9c895d4d68a6d7ad1a00bb1333_9366/adilette-comfort-sandals.jpg",
    title: "VINTAS EARTH - HIGH TOP - GOAT",
    code: "A61042",
    desc: "Sử dụng đồng thời chất liệu da Nappa, da Suede và vải Canvas trên kiểu dáng High Top cổ điển, tông màu trầm mặc gợi nhắc đến cây rừng đất đá. Một sản phẩm dành cho những tâm hồn thích lang thang, yêu tự do và mê xê dịch.",
    price: 495000,
    slider: [
      "https://ananas.vn/wp-content/uploads/pro_ABC100_1-500x500.jpg",
      "https://ananas.vn/wp-content/uploads/pro_A61102_1.jpg",
      "https://ananas.vn/wp-content/uploads/pro_vintas_A61039_1.jpg",
      "https://ananas.vn/wp-content/uploads/stu_basas_A61023_1-500x500.jpg",
    ],
  },
];
